module.exports = __webpack_public_path__ + "static/media/Acne-Pink-Kai-Taupe-Wool-Jumper-for-Men-Lyst.26e4f341.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/Acne-Pink-Kai-Taupe-Wool-Jumper-for-Men-Lyst.png
// module id = 252
// module chunks = 0